import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import subscribeImage from "../img/4957160.jpg";
import { submitNewsLetter } from "../apiServices/newsLetterServices";
import { useSnackbar } from "notistack";

const SubscribeModal = ({
  show,
  setShow,
  NewsLetterClick,
  setNewsLetterClick,
}) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const isFirstRender = useRef(true); // Track first render

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (NewsLetterClick && typeof setShow === "function") {
      setShow(true);
    }
  }, [NewsLetterClick]);

  useEffect(() => {
    const hasSubscribed = sessionStorage.getItem("hasSubscribed");

    if (!hasSubscribed) {
      const timer = setTimeout(() => {
        console.log("show before set:", show);

        if (typeof setShow === "function") {
          setShow(true);
          sessionStorage.setItem("hasSubscribed", "true");
        } else {
          console.error("setShow is not a function", setShow);
        }
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, []);

  // 🔹 Close modal and reset NewsLetterClick state
  const handleClose = () => {
    setShow(false);
    if (NewsLetterClick) {
      setNewsLetterClick(false);
    }
  };

  // 🔹 Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      await submitNewsLetter(email);
      enqueueSnackbar("Thank you for subscribing!", { variant: "success" });
      setError(null);
      setEmail(""); // Clear email field
      handleClose(); // Close modal after successful subscription
    } catch (error) {
      if (error.response?.status === 400) {
        enqueueSnackbar("You are already subscribed to our newsletter.", {
          variant: "info",
        });
      } else {
        enqueueSnackbar("Failed to subscribe. Please try again.", {
          variant: "error",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="subscribe-modal"
      className="p-4 p-md-0"
      style={{ borderRadius: "0" }}
    >
      <Modal.Body
        className="p-0 position-relative"
        style={{ borderRadius: "0" }}
      >
        <Button
          variant="light"
          onClick={handleClose}
          className="position-absolute top-0 end-0 m-0 p-0 fs-4 border-0"
          style={{ zIndex: 10, backgroundColor: "transparent" }}
        >
          &times;
        </Button>
        <Row>
          <Col md={6} className="d-block p-0">
            <img
              src={subscribeImage}
              alt="Subscribe"
              className="img-fluid h-100 w-100"
              style={{ borderRadius: "0" }}
            />
          </Col>
          <Col
            md={6}
            className="p-4 d-flex justify-content-center text-center align-items-center flex-column"
            style={{ backgroundColor: "#f8f9fa" }}
          >
            <Col md={12} className="text-center">
              <h5 className="mb-3">
                Would you like to Subscribe to our Newsletter?
              </h5>
            </Col>
            <Col md={12} className="text-center">
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formEmail">
                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="mb-3"
                    disabled={loading}
                  />
                </Form.Group>
                {error && <div className="text-danger mb-2">{error}</div>}
                <button
                  className="w-100 btn btn-green-theme"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Subscribing..." : "Subscribe Now"}
                </button>
              </Form>
            </Col>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default SubscribeModal;
